var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer-background",attrs:{"id":"Footer"}},[_c('IconLogo02'),_c('div',{staticClass:"copyright"},[_vm._v("©︎2021 SOGO SHIKAKU CO.,LTD")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }